import { render, staticRenderFns } from "./FichaPcoCircuitoComponent.vue?vue&type=template&id=b186c4f0"
import script from "./FichaPcoCircuitoComponent.vue?vue&type=script&lang=js"
export * from "./FichaPcoCircuitoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports